import { render, staticRenderFns } from "./footersGF.vue?vue&type=template&id=c59b3652&scoped=true"
import script from "./footersGF.vue?vue&type=script&lang=js"
export * from "./footersGF.vue?vue&type=script&lang=js"
import style0 from "./footersGF.vue?vue&type=style&index=0&id=c59b3652&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59b3652",
  null
  
)

export default component.exports